const localeConfig = require('./src/configs/i18n/locales.json')

module.exports = {
  i18n: {
    defaultLocale: localeConfig.defaultLocale,
    locales: localeConfig.locales,
    localeDetection: false,
  },
  fallbackLng: localeConfig.fallbackLocale,
  supportedLngs: localeConfig.locales,
  nonExplicitSupportedLngs: true,
  load: 'currentOnly',
}
